/* global sendGaEvents */
import * as constants from '../config';
import { showModal, hideModal, hideModals } from '../utility';

const triggerExitIntentBanner = () => {
  const currentUrl = window.location.pathname;
  const exitIntentModal = document.getElementById('exit-intent');
  const videoModal = document.getElementById('exit-intent-video-modal');
  const iframe = document.getElementById('exit-intent-iframe');

  // Exit intent modal is required, but video modal and iframe are optional
  if (!exitIntentModal) {
    return;
  }

  const extractPageKey = (url) => {
    const lastSegment = url.split('/').filter(Boolean).pop() || 'home';
    return `fyle-exit-intent-${lastSegment}`;
  };

  const showExitIntentModal = () => {
    const pageKey = extractPageKey(currentUrl);
    const isShown = sessionStorage.getItem(pageKey);
    // Check for visible modals using Bootstrap's .show class or inline display styles
    const isVisible = document.querySelector('.modal.show') || document.querySelector('.modal[style*="display: block"]') || document.querySelector('.modal[style*="display:block"]');

    if (isShown || isVisible) {
      return;
    }

    setTimeout(() => {
      showModal('exit-intent');
      sessionStorage.setItem(pageKey, true);
    }, 500);
  };

  const handleDownloadClick = () => {
    const downloadElement = document.querySelector('.exit-intent-card-body-download');
    const thankyouElement = document.querySelector('.exit-intent-card-body-thankyou');
    
    if (downloadElement) {
      downloadElement.style.display = 'none';
    }
    if (thankyouElement) {
      thankyouElement.style.display = 'block';
    }
  };

  const handleExperienceClick = () => {
    // Only handle experience click if video modal and iframe exist
    if (iframe && videoModal) {
      iframe.setAttribute('src', constants.exitIntentDemo);
      // Single modal operation: hide one, show another
      hideModal('exit-intent');
      showModal('exit-intent-video-modal');
    }
  };

  // Only enable exit intent on desktop
  const isDesktop = window.innerWidth >= 992;
  if (isDesktop) {
    document.addEventListener('mouseleave', showExitIntentModal);
  }

  const downloadBtn = document.getElementById('exit-intent-banner-download-btn');
  const experienceBtn = document.getElementById('exit-intent-experience-now-btn');
  
  if (downloadBtn) {
    downloadBtn.addEventListener('click', handleDownloadClick);
  }
  if (experienceBtn) {
    experienceBtn.addEventListener('click', handleExperienceClick);
  }
};

const clickOutsideToHideContent = (hideContent) => {
  document.addEventListener('click', (event) => {
    if (!hideContent) {
      // Check the click is outside demo form modal
      const demoModal = event.target.closest('#contact-us-modal');

      // If demoform is opened and closed from outside send ga event
      if (demoModal && !demoModal.classList.contains('show')) {
        sendGaEvents('click-close-modal', 'form-close', 'demo-form');
        // to trigger exit banner once per session, after demo form is closed
        if (!sessionStorage.getItem('demoFormClosed')) {
          sessionStorage.setItem('demoFormClosed', 'true');
          triggerExitIntentBanner();
        }
      }

      // send a GA event when exit intent banner is closed by clicking outside the modal
      if (event.target.id === 'exit-intent' && !event.target.classList.contains('show')) {
        sendGaEvents('click-close-modal', 'form-close', 'demo-form');
        // Close multiple related modals when exit intent is closed
        hideModals(['exit-intent', 'exit-intent-video-modal']);
      }
    } else {
      hideContent();
    }
  });
};

// Function to check if modal is open
// To resolve issue when multiple modals are open
const checkModalIsOpen = () => {
  // If modal is open
  const modals = document.querySelectorAll('.modal');
  modals.forEach((modal) => {
    modal.addEventListener('shown.bs.modal', () => {
      // Add class to body
      document.body.classList.add('modal-open');
    });
    
    // Also handle modal hide events to properly manage body class
    modal.addEventListener('hide.bs.modal', () => {
      // Small delay to check for other open modals after this one closes
      setTimeout(() => {
        const openModals = document.querySelectorAll('.modal.show');
        if (openModals.length === 0) {
          document.body.classList.remove('modal-open');
        }
      }, 100);
    });
  });
};

export {
  triggerExitIntentBanner,
  clickOutsideToHideContent,
  checkModalIsOpen,
};